'use client';
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import classnames from 'classnames';
import { nanoid } from 'nanoid';
import { Button, TextInput, Label, FieldNote } from '../../index.js';
export const Counter = React.forwardRef((_a, ref) => {
    var { className, disabled, min, max, readOnly, ariaDescribedBy, ariaLabelledBy, hideLabel, isError, fieldNote, id, label, minusButtonText = 'Subtract 1', optionalLabel, plusButtonText = 'Add 1', required = true, requiredLabel, labelAfter, horizontal, value } = _a, other = __rest(_a, ["className", "disabled", "min", "max", "readOnly", "ariaDescribedBy", "ariaLabelledBy", "hideLabel", "isError", "fieldNote", "id", "label", "minusButtonText", "optionalLabel", "plusButtonText", "required", "requiredLabel", "labelAfter", "horizontal", "value"]);
    const [count, setCountState] = React.useState(value !== undefined ? parseInt(`${value}`) : 1);
    const [idVar, setId] = React.useState();
    const [ariaLabelledByVar, setAriaLabelledBy] = React.useState();
    const [ariaDescribedByVar, setAriaDescribedBy] = React.useState();
    React.useEffect(() => {
        setId(id || nanoid());
        setAriaLabelledBy(ariaLabelledBy || nanoid());
        if (fieldNote) {
            setAriaDescribedBy(ariaDescribedBy || nanoid());
        }
    }, [ariaDescribedBy, ariaLabelledBy, fieldNote, id]);
    function onIncrease(e) {
        e.preventDefault();
        setCountState(count + 1);
    }
    function onDecrease(e) {
        e.preventDefault();
        setCountState(count - 1);
    }
    function onChange(e) {
        setCountState(parseInt(e.target.value.replace(/\D/, '')));
    }
    const componentClassName = classnames('sparky-c-counter', className, {
        'sparky-is-error': isError,
        'sparky-is-disabled': disabled,
        'sparky-c-counter--horizontal': horizontal,
    });
    return (_jsxs("div", Object.assign({ className: componentClassName }, other, { children: [_jsx(Label, { className: "sparky-c-counter__label", htmlFor: idVar, text: label, bold: false, hideLabel: hideLabel, labelAfter: labelAfter, required: required, optionalLabel: optionalLabel, requiredLabel: requiredLabel }), _jsxs("div", Object.assign({ className: "sparky-c-counter__body" }, { children: [_jsx(Button, { className: "sparky-c-counter__btn sparky-c-counter__btn--minus", iconPosition: "after", iconName: "minus", hideText: true, text: minusButtonText, disabled: disabled || (min !== undefined && count === min), onClick: onDecrease }), _jsx(TextInput, { className: "sparky-c-counter__input", type: "text", pattern: "[0-9]*", float: false, min: min, max: max, disabled: disabled, readOnly: readOnly, "aria-live": "assertive", id: idVar, value: String(count), onChange: onChange, "aria-labelledby": ariaLabelledByVar, ariaDescribedBy: ariaDescribedByVar, ref: ref }), _jsx(Button, { className: "sparky-c-counter__btn sparky-c-counter__btn--plus", iconPosition: "after", iconName: "plus", hideText: true, text: plusButtonText, disabled: disabled || (max !== undefined && count === max), onClick: onIncrease })] })), fieldNote && (_jsx(FieldNote, Object.assign({ className: "sparky-c-counter-field__note", id: ariaDescribedByVar }, { children: fieldNote }))), _jsx("div", Object.assign({ id: ariaLabelledByVar, className: "sparky-u-is-vishidden" }, { children: label ? `${count} ${label}` : `${count}` }))] })));
});
Counter.displayName = 'Counter';
//# sourceMappingURL=Counter.js.map